<template>
    <div>
        <buttonlist @help="help"  @exps="exps" @opentable="opentable" @search="search" @reflash="reflash" ref="SetBtn"></buttonlist>
        <el-tabs :tab-position="'top'" v-model="activeName" @tab-click="selectInfo" >
            <el-tab-pane :label="$t('getapi[12459]')" name="0">
                <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
                    <li style="width: 100%; margin-top:0px;">
                        <vTable
                                id="xpane-0"
                                :data="dataSet"
                                :loading="loading"
                                queryData="SOPartCostViewList"
                                :filter_thousandth="['receive_net_unit_price','actually_avg_qty','so_part_amount','std_stuff_qty','so_stuff_qty']"
                                :header="tableHeader"
                                :height="tableHeight"
                                :option="tableOption"
                                ref="singleTable"
                                :showfooter="true"
                                :checkflg="false"
                        ></vTable>
                    </li>
                </ul>
            </el-tab-pane>
            <el-tab-pane :label="$t('getapi[12631]')" name="1">
                <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
                    <li style="width: 100%; margin-top:0px;">
                        <vTable
                                id="xpane-1"
                                :data="dataSet1"
                                :loading="loading"
                                queryData="SOPartCostViewList"
                                :filter_thousandth="['receive_net_unit_price','actually_avg_qty','so_part_amount']"
                                :header="tableHeader1"
                                :height="tableHeight"
                                :option="tableOption"
                                ref="singleTable1"
                                :showfooter="true"
                                :checkflg="false"
                        ></vTable>
                    </li>
                </ul>
            </el-tab-pane>
            <el-tab-pane :label="$t('getapi[12863]')" name="2">
                <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
                    <li style="width: 100%; margin-top:0px;">
                        <vTable
                                id="xpane-2"
                                :data="dataSet2"
                                :loading="loading"
                                queryData="SOPartCostViewList"
                                :filter_thousandth="['receive_net_unit_price','actually_avg_qty','so_part_amount','std_stuff_qty','so_stuff_qty']"
                                :header="tableHeader2"
                                :height="tableHeight"
                                :option="tableOption"
                                ref="singleTable1"
                                :showfooter="true"
                                :checkflg="false"
                        ></vTable>
                    </li>
                </ul>
            </el-tab-pane>
        </el-tabs>
        <!-- <el-row>
            <el-col :span="18">
                <el-pagination
                        style="margin-top: 1em"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 60px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
            </el-col>
        </el-row> -->

        <serce :isVisible="isVisible" queryData="SOPartCostViewList" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[12459]')" queryData="SOPartCostViewList" :tabNo="tabNo" ref="ctab"
                @getctab="sortclick"></ctable>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
        name:'2_sopartcost',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3- Common.reduceTableHeight2,
                    maxHeight: this.$windowSize.tableHeight3- Common.reduceTableHeight2,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                dataSet1: [], // 主表数据汇总
                dataSet2: [],
                tableHeader: [],
                tableHeader1:[],
                tableHeader2:[],
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('2_sopartcost'), // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                isVisible: false,
                activeName: '0', // 当前选择的分页
                SelectIndex:0,
                tabNo:"0",
                scrollTop:0,
                scrollTop1:0,
            };
        },
        mounted: function() {
            let that = this;
            that.colsort();
            that.userData = sessionStorage.getItem('userData');
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop1;
                }, 13)
            })
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('SOPartCostViewList', that.tabNo, PFileds => {
                    if(that.tabNo==0){
                        that.tableHeader=PFileds;	
                        that.SelectIndex = 0;
                        that.tabNo="0";
                        that.title=that.$t('getapi[12459]')//"物料主文件(基础信息)";	
                    }
                    else if(that.tabNo==1){
                        that.tableHeader1=PFileds;		
                    }
                    else if(that.tabNo==2){
                        that.tableHeader2=PFileds;
                    }
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[12459]"),this.$t("getapi[20]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                 //只读权
                 that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.pageIndex=1;
                that.$refs.ser.clearInput(that.isVisible, 'SOPartCostViewList');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            
            selectInfo(tab, event) {
                let that = this;
                if (that.activeName ==0) {
                    that.SelectIndex = 0;
                    that.tabNo="0";
                    that.title=that.$t('getapi[12459]')//"物料主文件(基础信息)";
                } else if (that.activeName ==1) {
                    that.SelectIndex = 1;
                    that.tabNo="1";
                    that.title=that.$t('getapi[12631]')//"物料主文件(计划相关)";
                } else if (that.activeName ==2) {
                    that.SelectIndex = 2;
                    that.tabNo="2";
                    that.title=that.$t('getapi[12863]')//"物料主文件(计划相关)";
                }
                that.$nextTick(function(){
                    that.$processdata.initForm(tab.name)
                });
                that.colsort();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: 0,
                    Param: datac
                };
                that.$http.urlpost('/Pro/MDIP/SOPartCostViewList', data, function(res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent.dt1;
                        that.dataSet1 = res.DataContent.dt2;
                        that.dataSet2 = res.DataContent.dt3;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.authority();
                    that.$nextTick(function () {
                        that.$processdata.initAllForm()
                    })
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('2_sopartcost',val)
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            // 导出
            exps() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    query_sign: "SOPartCostViewList",
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    Param: datac,
                    SelectIndex: that.SelectIndex,
                    fromname: that.title,
                };
                that.$http.urlpost('/Basic/ExportToExecl', data, function(res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                    that.loading = false;
                });
            },
            footerMethod({columns, data}) {
                const footerData = [
                    columns.map((column, _columnIndex) => {
                        if (_columnIndex === 0) {
                            return '合计'
                        }
                        if (['so_part_amount'].includes(column.property)) {
                            return this.sumNum(data, 'so_part_amount')
                        }
                        return null
                    }),
                ]
                return footerData
            },
            sumNum(costForm, type) {
                // if (type == 'so_part_amount') {
                //     let total = 0.0
                //     for (let i = 0; i < costForm.length; i++) {
                //         total = this.countNum(total , costForm[i].so_part_amount)
                //     }
                //     console.log("测试1:"+total.toString())
                //     return total.toString().replace(/\d+/, function(n){ // 先提取整数部分
                //         return n.replace(/(\d)(?=(\d{3})+$)/g,function($1){
                //             return $1+",";
                //         });
                //     })
                // }
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    .bbl {
        margin: 0px auto 10px;
        white-space: pre;
        span {
            margin-left: 10px;
            min-width: 70px;
            text-align: left;
            line-height: 20px;
            display: inline-block;
            margin-right: 0px;
        }
    }
</style>
